import {GnbMenuId} from '../constant';

export function getGnbMenuActionName(gnbMenuId: GnbMenuId) {
  return gnbMenuIdActionNameMap[gnbMenuId];
}

const gnbMenuIdActionNameMap = {
  [GnbMenuId.Prefer]: '홈메뉴_추천_클릭',
  [GnbMenuId.Webtoon]: '홈메뉴_웹툰_클릭',
  [GnbMenuId.Webnovel]: '홈메뉴_웹소설_클릭',
  [GnbMenuId.Book]: '홈메뉴_책_클릭',
  [GnbMenuId.Shortcut]: '홈메뉴_바로가기_클릭',
  [GnbMenuId.DayOfWeek]: '홈메뉴_요일연재_클릭',
};
